<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-group-line me-1 text-primary"></i>Employees
                </h5>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Search employees by name."
                    placement="top" container="body">
                    <i class="bx bx-search-alt"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" id="search" placeholder="Search..."
                    autocomplete="off" [(ngModel)]="searchKeyword">
                </div>
              </div>
              <div class="col-sm-12 col-md-auto">
                <button type="button" class="btn btn-secondary" (click)="upsertEmployee()"
                  [ngClass]="{'not-allowed':!privilege.canEdit}"
                  [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.employee.edit' : ''">
                  <i class="bx bx-plus"></i> Add Employee
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="200">Name</th>
                  <th scope="col" width="200">Email</th>
                  <th scope="col" width="200">Reported To</th>
                  <th scope="col" width="150">Joining Date</th>
                  <th scope="col" width="150">Date of Birth</th>
                  <th scope="col" width="150" class="text-center">Status</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of employees | search : 'employeeData.name' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{employee.employeeData?.name}} {{employee?.employeeData?.surname}}</td>
                  <td>{{employee.employeeData?.email}}</td>
                  <td>{{employee.employeeData?.reportToName}}</td>
                  <td>{{employee.employeeData?.doj | date:'MMM dd, yyyy'}}</td>
                  <td>{{employee.employeeData?.dob | date:'MMM dd, yyyy'}}</td>
                  <td class="text-center ">
                    <!-- Verified/Unverified Icon (Left) -->
                    <i class="bx" 
                       [ngClass]="{'bx-user-check text-success': employee.userData?.verified, 
                                   'bx-user-x text-danger': !employee.userData?.verified}"
                       style="font-size: 20px; width: 20px; height: 20px;"
                       [ngbTooltip]="employee.userData?.verified ? 'Verified Employee' : 'Unverified Employee'"
                       placement="top" container="body">
                    </i>
                    <!-- Active/Inactive Icon (Right) -->
                    <i class="ri-shield-check-line ms-2" 
                       [ngClass]="{'text-success': !employee.employeeData?.disabled, 
                                   'text-danger': employee.employeeData?.disabled}"
                       style="font-size: 20px; width: 20px; height: 20px;"
                       [ngbTooltip]="employee.employeeData?.disabled ? 'Inactive Employee' : 'Active Employee'"
                       placement="top" container="body">
                    </i>
                  </td>
                  <td class="actions mt-1">
                    <i class="bx bx-edit alert-primary"
                      [ngClass]="{'no-event':employee?.employeeData?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                      [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.employee.edit' : 'Update employee'"
                      (click)="upsertEmployee(employee)"></i>
                    <!-- <i *ngIf="!employee?.employeeData?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                        [ngClass]="{'not-allowed':!privilege.canDelete}"
                        [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): setup.employee.delete' : 'Delete employee'"
                        (click)="deleteEmployee(employee,i)"></i> -->
                    <div *ngIf="employee?.employeeData?.isDeleteInProgress" role="status"
                      class="spinner-border spinner-border-sm text-danger">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="8">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="employees && employees.length < 1; else noSearchResults">
                      <td colspan="8">No employees were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="8"
                        *ngIf="searchKeyword && (employees | search : 'employeeData.name' : searchKeyword).length == 0">
                        No employees were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>